import React, { useContext, useEffect, useState } from "react";
import "../../styles/listsOverview.css";
import LoadingIcon from "../../images/Loading_icon.gif";
import POWithFilter from "./POWithFilter";
import POFilter from "./POFilter";
import POSingleProject from "./POSingleProject";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function POContainer({
  refreshAfterFilter,
  setRefreshAfterFilter,
}) {
  const { API_URL } = useContext(UrlContext);
  const { listOverview, setListOverview, loading, users, owners } =
    useContext(AppContext);

  const [loadMoreProjects, setLoadMoreProjects] = useState(true);
  const [page, setPage] = useState(1);
  const bottomRef = React.createRef();
  const [waitFivesec, setWaitFivesec] = useState(true);
  const [noMoreProjects, setNoMoreProjects] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [zohoIdFilter, setZohoIdFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [prjTypeFilter, setPrjTypeFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [industryFilter, setIndustryFilter] = useState("");
  const [ownerFilter, setOwnerFilter] = useState("");
  const [filterPage, setFilterPage] = useState(1);
  const [filterUsed, setFilterUsed] = useState(false);

  useEffect(() => {
    if (refreshAfterFilter) {
      setRefreshAfterFilter(true);
      setListOverview([]);
      setFilterPage(1);
      setLoadMoreProjects(true);
      setNoMoreProjects(false);
      setFilterUsed(false);
      setWaitFivesec(true);
      setRefreshAfterFilter(false);
    }
  }, [refreshAfterFilter]);

  useEffect(() => {
    if (
      searchInput ||
      zohoIdFilter ||
      statusFilter ||
      ownerFilter ||
      prjTypeFilter ||
      regionFilter ||
      countryFilter ||
      industryFilter
    ) {
      setFilterUsed(true);
      setListOverview([]);
    } else if (
      filterUsed &&
      !(
        searchInput ||
        zohoIdFilter ||
        statusFilter ||
        ownerFilter ||
        prjTypeFilter ||
        regionFilter ||
        countryFilter ||
        industryFilter
      )
    ) {
      setRefreshAfterFilter(true);
    }
  }, [
    searchInput,
    zohoIdFilter,
    statusFilter,
    ownerFilter,
    prjTypeFilter,
    regionFilter,
    countryFilter,
    industryFilter,
  ]);

  useEffect(() => {
    if (
      loadMoreProjects &&
      !(
        searchInput ||
        zohoIdFilter ||
        statusFilter ||
        ownerFilter ||
        prjTypeFilter ||
        regionFilter ||
        countryFilter ||
        industryFilter
      )
    ) {
      setLoadMoreProjects(false);
      if (!listOverview?.length) {
        const ephToken = localStorage.getItem("eph-token");
        const token = JSON.parse(ephToken).value;
        const url = `${API_URL}lists-overview/` + page;
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.data.length > 0) {
              setListOverview([...data.data]);
            } else {
              setNoMoreProjects(true);
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Database connection error!",
              text: "Please logout and try again.",
              confirmButtonText: "OK",
            });
            console.log(err);
          });
      }
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !waitFivesec && !noMoreProjects) {
        setWaitFivesec(true);

        setLoadMoreProjects(true);
      }
    });

    if (bottomRef.current) {
      observer.observe(bottomRef.current);
    }

    return () => {
      if (bottomRef.current) {
        observer.unobserve(bottomRef.current);
      }
    };
  }, [waitFivesec, noMoreProjects]);

  useEffect(() => {
    if (waitFivesec) {
      setTimeout(() => {
        setWaitFivesec(false);
      }, 4000);
    }
  }, [waitFivesec]);

  if (
    searchInput ||
    zohoIdFilter ||
    statusFilter ||
    ownerFilter ||
    prjTypeFilter ||
    regionFilter ||
    countryFilter ||
    industryFilter
  ) {
    return (
      <div>
        <div className="project-overview-table container-div">
          <POFilter
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            zohoIdFilter={zohoIdFilter}
            setZohoIdFilter={setZohoIdFilter}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            ownerFilter={ownerFilter}
            setOwnerFilter={setOwnerFilter}
            prjTypeFilter={prjTypeFilter}
            setPrjTypeFilter={setPrjTypeFilter}
            regionFilter={regionFilter}
            setRegionFilter={setRegionFilter}
            countryFilter={countryFilter}
            setCountryFilter={setCountryFilter}
            industryFilter={industryFilter}
            setIndustryFilter={setIndustryFilter}
            owners={owners}
          />

          <POWithFilter
            searchInput={searchInput}
            zohoIdFilter={zohoIdFilter}
            statusFilter={statusFilter}
            ownerFilter={ownerFilter}
            filterPage={filterPage}
            prjTypeFilter={prjTypeFilter}
            regionFilter={regionFilter}
            countryFilter={countryFilter}
            industryFilter={industryFilter}
            setFilterPage={setFilterPage}
            users={users}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      {listOverview.length ? (
        <div className="project-overview-table container-div">
          <POFilter
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            zohoIdFilter={zohoIdFilter}
            setZohoIdFilter={setZohoIdFilter}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            ownerFilter={ownerFilter}
            setOwnerFilter={setOwnerFilter}
            prjTypeFilter={prjTypeFilter}
            setPrjTypeFilter={setPrjTypeFilter}
            regionFilter={regionFilter}
            setRegionFilter={setRegionFilter}
            countryFilter={countryFilter}
            setCountryFilter={setCountryFilter}
            industryFilter={industryFilter}
            setIndustryFilter={setIndustryFilter}
            owners={owners}
          />

          {listOverview.map((project, index) => {
            return (
              <div className="flex items-center justify-center">
                <div className="w-[97%]">
                  <POSingleProject
                    key={index}
                    project={project}
                    users={users}
                    filtering={false}
                  />
                </div>
              </div>
            );
          })}

          {/* {!noMoreProjects && (
          <>
            <div style={{ textAlign: "center", marginTop: "50px" }}>
              <img
                src={LoadingIcon}
                style={{ height: "50px" }}
                alt="Loading projects..."
              />
              {!listOverview.length > 0 && (
                <h4 style={{ marginTop: "20px" }}>please wait</h4>
              )}
            </div>
            {listOverview.length > 0 ? (
              <div
                ref={bottomRef}
                style={{ marginBottom: "200px", marginTop: "20px" }}
              >
                <h4 style={{ textAlign: "center" }}>please wait</h4>
              </div>
            ) : null}
          </>
        )} */}
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <img
            src={LoadingIcon}
            style={{ height: "50px" }}
            alt="Loading projects..."
          />
          {!listOverview.length > 0 && (
            <h4 style={{ marginTop: "20px" }}>please wait</h4>
          )}
        </div>
      )}
    </div>
  );
}
